/* Gogo Language Texts

Table of Contents

01.General
02.User Login, Logout, Register
03.Menu
04.Dashboards
05.Pages
06.Applications
  06.01.Chat
  06.02.Survey
  06.03.Todo
07.UI
  07.01.Alerts
  07.02.Badges
  07.03.Buttons
  07.04.Cards
  07.05.Carousel
  07.06.Charts
  07.07.Collapse
  07.08.Dropdowns
  07.09.Editors
  07.10.Forms
  07.11.Form Components
  07.12.Icons
  07.13.Input Groups
  07.14.Jumbotron
  07.15.Modal
  07.16.Navigation
  07.17.Popover & Tooltip
  07.18.Sortable
  07.19.Maps
  07.20.Tables
*/
const itMessages = {
  /* 01. Generale */
  'general.copyright': 'Myma.ai © 2019 Tutti i diritti riservati.',

  /* 02. Login, Registrazione, Recupero Password */
  'user.login-title': 'Login',
  'user.register': 'Registrati',
  'user.forgot-password': 'Password dimenticata',
  'user.email': 'E‑mail',
  'user.newpassword': 'Nuova password',
  'user.currentpassword': 'Password corrente',
  'user.newpasswordagain': 'Ripeti nuova password',
  'user.password': 'Password',
  'user.forgot-password-question': 'Hai dimenticato la password?',
  'user.fullname': 'Nome completo',
  'user.firstname': 'Nome',
  'user.lastname': 'Cognome',
  'user.login-button': 'ACCEDI',
  'user.register-button': 'REGISTRATI',
  'user.reset-password-button': 'RESETTA',
  'user.buy': 'ACQUISTA',
  'user.username': 'Nome utente',

  /* 03. Menu */
  'menu.app': 'Casa',
  'menu.online': 'In linea',
  'menu.offline': 'Non in linea',
  'menu.default': 'Predefinito',
  'menu.analytics': 'Analisi',
  'menu.ecommerce': 'E‑commerce',
  'menu.content': 'Contenuti',
  'menu.pages': 'Pagine',
  'menu.data-list': 'Elenco dati',
  'menu.thumb-list': 'Elenco con anteprime',
  'menu.image-list': 'Elenco immagini',
  'menu.details': 'Dettagli',
  'menu.search': 'Cerca',
  'menu.login': 'Login',
  'menu.register': 'Registrati',
  'menu.forgot-password': 'Password dimenticata',
  'menu.error': 'Errore',
  'menu.applications': 'Applicazioni',
  'menu.todo': 'Lista attività',
  'menu.survey': 'Sondaggi',
  'menu.chat': 'Chat',
  'menu.ui': 'UI',
  'menu.edit': 'Modifica',
  'menu.alerts': 'Avvisi',
  'menu.badges': 'Badge',
  'menu.buttons': 'Pulsanti',
  'menu.cards': 'Schede',
  'menu.carousel': 'Carousel',
  'menu.charts': 'Grafici',
  'menu.collapse': 'Collassable',
  'menu.dropdowns': 'Dropdown',
  'menu.editors': 'Editor',
  'menu.form-layouts': 'Layout modulo',
  'menu.form-components': 'Componenti modulo',
  'menu.form-validations': 'Validazioni modulo',
  'menu.icons': 'Icone',
  'menu.input-groups': 'Gruppi di input',
  'menu.jumbotron': 'Jumbotron',
  'menu.modal': 'Modale',
  'menu.navigation': 'Navigazione',
  'menu.popover-tooltip': 'Popover & Tooltip',
  'menu.sortable': 'Ordinabile',
  'menu.tables': 'Tabelle',
  'menu.menu': 'Menu',
  'menu.subhidden': 'Sotto‑nascosto',
  'menu.hidden': 'Nascosto',
  'menu.visible': 'Visibile',
  'menu.maps': 'Mappe',
  'menu.landingpage': 'Landing Page',
  'menu.multipage-home': 'Home multipagina',
  'menu.singlepage-home': 'Home monopagina',
  'menu.about': 'Chi siamo',
  'menu.auth-login': 'Auth Login',
  'menu.auth-register': 'Auth Registrati',
  'menu.blog': 'Blog',
  'menu.blog-detail': 'Dettaglio blog',
  'menu.careers': 'Lavora con noi',
  'menu.confirmation': 'Conferma',
  'menu.contact': 'Contatti',
  'menu.docs': 'Documenti',
  'menu.features': 'Caratteristiche',
  'menu.prices': 'Prezzi',
  'menu.videos': 'Video',
  'menu.mailing': 'Mailing',
  'menu.invoice': 'Fattura',
  'menu.blank-page': 'Prossimamente...',
  'menu.types': 'Tipi di menu',
  'menu.levels': 'Livelli di menu',
  'menu.third-level-1': 'Terzo livello 1',
  'menu.third-level-2': 'Terzo livello 2',
  'menu.third-level-3': 'Terzo livello 3',

  /* 04. Dashboard */
  'dashboards.update': 'Aggiorna',
  'dashboards.save': 'Salva',
  'dashboards.saveSchedule': 'Salva pianificazione',
  'dashboards.name': 'Nome',
  'dashboards.button': 'Pulsante',
  'dashboards.visits': 'Visite',
  'dashboards.checkAvailability': 'Verifica disponibilità o tariffe',
  'dashboards.details': 'Dettagli',
  'dashboards.pending-orders': 'Ordini in sospeso',
  'dashboards.completed-orders': 'Ordini completati',
  'dashboards.refund-requests': 'Richieste di rimborso',
  'dashboards.new-comments': 'Nuovi commenti',
  'dashboards.sales': 'Vendite',
  'dashboards.orders': 'Ordini',
  'dashboards.refunds': 'Rimborsi',
  'dashboards.recent-orders': 'Ordini recenti',
  'dashboards.product-categories': 'Categorie di prodotti',
  'dashboards.cakes': 'Torte',
  'dashboards.tickets': 'Biglietti',
  'dashboards.calendar': 'Calendario',
  'dashboards.best-sellers': 'Best Seller',
  'dashboards.per-session': 'Per sessione',
  'dashboards.profile-status': 'Stato profilo',
  'dashboards.payment-status': 'Stato pagamento',
  'dashboards.work-progress': 'Avanzamento lavori',
  'dashboards.tasks-completed': 'Attività completate',
  'dashboards.payments-done': 'Pagamenti effettuati',
  'dashboards.order-stock': 'Ordina - Scorte',
  'dashboards.categories': 'Categorie',
  'dashboards.quick-post': 'Post rapido',
  'dashboards.title': 'Titolo',
  'dashboards.content': 'Contenuto',
  'dashboards.ticket-count': 'Conteggio ticket',
  'dashboards.commonticketsubmission': 'Invii ticket comuni',
  'dashboards.category': 'Categoria',
  'dashboards.save-and-publish': 'Salva e pubblica',
  'dashboards.top-viewed-posts': 'Post più visti',
  'dashboards.posts': 'Post',
  'dashboards.pending-for-publish': 'In attesa di pubblicazione',
  'dashboards.users': 'Utenti',
  'dashboards.on-approval-process': 'In approvazione',
  'dashboards.alerts': 'Avvisi',
  'dashboards.waiting-for-notice': 'In attesa di avviso',
  'dashboards.files': 'File',
  'dashboards.pending-for-print': 'In attesa di stampa',
  'dashboards.logs': 'Log',
  'dashboards.gogo': 'GOGO',
  'dashboards.magic-is-in-the-details': 'LA MAGIA STA NEI DETTAGLI',
  'dashboards.yes-it-is-indeed': 'Sì, lo è davvero!',
  'dashboards.advanced-search': 'Ricerca avanzata',
  'dashboards.toppings': 'Guarnizioni',
  'dashboards.type': 'Tipo',
  'dashboards.keyword': 'Parola chiave',
  'dashboards.search': 'Cerca',
  'dashboards.top-rated-items': 'Elementi più votati',
  'dashboards.country': 'Paese',
  'dashboards.webVisitors': 'Visitatori web',
  'dashboards.avatarClicks': 'Click avatar',
  'dashboards.wordCloud': 'Word Cloud',
  'dashboards.topic': 'Argomento',
  'dashboards.roomsAvailability': 'Camere & disponibilità',
  'dashboards.startChat': 'Avvia chat',
  'dashboards.restaurantsBars': 'Ristoranti & bar',
  'dashboards.groupBooking': 'Prenotazione di gruppo',
  'dashboards.promotions': 'Promozioni',
  'dashboards.weedingevents': 'Matrimoni & eventi',
  'dashboards.lostsomething': 'Hai perso qualcosa?',
  'dashboards.producttext': 'Testo prodotto',
  'dashboards.bookingroomnew': 'Nuova prenotazione stanza',
  'dashboards.email': 'E‑mail',
  'dashboards.phone': 'Telefono',
  'dashboards.zipcode': 'CAP',
  'dashboards.marketingconsent': 'Consenso marketing',
  'dashboards.additionalinfo': 'Informazioni aggiuntive',
  'dashboards.viewallcontacts': 'Visualizza tutti i contatti',
  'dashboards.current': 'Corrente',
  'dashboards.last7days': 'Ultimi 7 giorni',
  'dashboards.last30days': 'Ultimi 30 giorni',
  'dashboards.thisweek': 'Questa settimana',
  'dashboards.thismonth': 'Questo mese',
  'dashboards.previousmonth': 'Mese precedente',
  'dashboards.yeartodate': 'Anno in corso',
  'dashboards.lastyear': 'Anno scorso',
  'dashboards.all': 'Tutti',
  'dashboards.standardOccupancy': 'Occupazione standard',
  'dashboards.max-occupancy': 'Occupazione massima',
  'dashboards.numberOfThisType': 'Numero di questo tipo',
  'dashboards.displayOrder': 'Ordine di visualizzazione',
  'dashboards.provider': 'Fornitore',
  'dashboards.edit': 'Modifica',
  'dashboards.delete': 'Elimina',
  'dashboards.addImages': 'Aggiungi immagini',
  'dashboards.near': 'Vicino',
  'dashboards.calling_party': 'Parte chiamante',
  'dashboards.called_party': 'Parte chiamata',
  'dashboards.lastdial': 'Ultima chiamata',
  'dashboards.imagelink': 'Link immagine',
  'dashboards.browsegallery': 'Sfoglia galleria',
  'dashboards.changelog': 'Registro modifiche',
  'dashboards.externalresources': 'Risorse esterne',
  'dashboards.webpage': 'Pagina web',
  'dashboards.web-pages': 'Pagine web',
  'dashboards.published': 'Pubblicato',
  'dashboards.adddocument': 'Aggiungi documento',
  'dashboards.ready-to-publish': 'Pronto per pubblicazione',
  'dashboards.draft': 'Bozza',
  'dashboards.order-by': 'Ordina per',
  'dashboards.add-faq': 'Aggiungi FAQ',
  'dashboards.collections': 'Collezioni',
  'dashboards.items': 'Elementi',
  'dashboards.rooms-availability': 'Camere & disponibilità',
  'dashboards.events-wedding-venues': 'Eventi & location per matrimonio',
  'dashboards.long-stay-enquiry': 'Richiesta soggiorno lungo',
  'dashboards.reservation-confirmation-request':
    'Richiesta conferma prenotazione',
  'dashboards.modify-cancel-booking': 'Modifica o cancella prenotazione',
  'dashboards.left-something-behind': 'Hai lasciato qualcosa?',
  'dashboards.invoice-copy': 'Copia fattura/scontrino',
  'dashboards.sync': 'Sincronizza',
  'dashboards.syncNow': 'Sincronizza ora',
  'dashboards.add-web-page': 'Aggiungi pagina web',
  'dashboards.sprint-title':
    'Incontra Sprint, la nostra automazione rivoluzionaria per addestrare modelli AI 10× più velocemente.',
  'dashboards.sprint-description':
    'Sprint lavora con te—per liberare la creatività, aumentare la produttività e ridurre drasticamente i tempi per addestrare l’Assistente Digitale.',
  'dashboards.sprint-feature':
    'La funzionalità Sprint è progettata per sincronizzare la conoscenza da fonti esterne, utile sia per l’avvio che per gli aggiornamenti continui. Quando eseguita su un sistema attivo, Sprint modifica il Knowledge Hub in base alle fonti esterne configurate, influenzando direttamente i comportamenti e risposte generati dall’IA. Per assistenza nell’impostazione di Sprint, contatta il nostro team di supporto.',
  'dashboards.change-password': 'Cambia password',
  'dashboards.sign-out': 'Esci',
  'dashboards.privacy-policy': 'Privacy',
  'dashboards.help-center': 'Centro assistenza',
  'dashboards.switch-account': 'Cambia account',
  'dashboards.business-settings': 'Impostazioni azienda',
  'dashboards.notifications-allowed': 'Notifiche abilitate',
  'dashboards.dark-theme': 'Tema scuro',
  'dashboards.online': 'Online',
  'dashboards.offline': 'Offline',
  'dashboards.invoice-&-payments': 'Fattura & pagamenti',
  'dashboards.upgrade-plan': 'Aggiorna piano',
  'dashboards.add-room': 'Aggiungi stanza',
  'dashboards.room-type': 'Tipo stanza',
  'dashboards.room-name': 'Nome stanza',
  'dashboards.how-many-guests': 'Ospiti totali per stanza',
  'dashboards.numberofBeds': 'Numero di letti',
  'dashboards.number-of-rooms-this-type': 'Numero di stanze (di questo tipo)',
  'dashboards.number-of-bedrooms': 'Numero di camere da letto',
  'dashboards.number-of-livingrooms': 'Numero di soggiorni',
  'dashboards.minimum-adults': 'Adulti minimi',
  'dashboards.maximum-adults': 'Adulti massimi',
  'dashboards.maximum-children': 'Bambini massimi',
  'dashboards.maximum-infants': 'Neonati massimi',
  'dashboards.extra-beds-allowed': 'Consenti letto extra',
  'dashboards.booking-engine-code': 'Codice engine prenotazioni',
  'dashboards.room-size': 'Dimensione stanza',
  'dashboards.balcony-area': 'Area balcone',
  'dashboards.unit': 'Unità',
  'dashboard.whatsapp_message': 'Digita il tuo messaggio qui...',
  'dashboard.whatsapp_reply_window':
    'Hai a disposizione una finestra di 24 ore per rispondere a un messaggio del cliente su WhatsApp Business a partire dal momento in cui il cliente ti ha inviato l’ultimo messaggio. Se rispondi entro questa finestra di assistenza clienti di 24 ore, puoi inviare qualsiasi tipo di messaggio. Dopo la chiusura della finestra di 24 ore, potrai inviare solo messaggi utilizzando Modelli di Messaggio pre-approvati, che riavviano la finestra di 24 ore quando il cliente risponde.',
  'dashboards.square-meters': 'Metri quadrati',
  'dashboard.pick_quick_reply':
    'Scegli una risposta rapida o digita il tuo messaggio',
  'dashboard.hang_in_there': 'Attendi mentre cerchiamo di collegarti!',
  'dashboard.outbound_msg': 'Quando inviare il messaggio in uscita',
  'dashboard.message_sent': 'Il tuo messaggio è stato inviato con successo!',
  'dashboard.failed_msg': 'Invio del messaggio non riuscito',
  'dashboard.new_chat_message': 'Nuovo messaggio di chat',
  'dashboard.user_msg':
    'C’è un messaggio dell’utente nelle ultime 24 ore. Puoi rispondere con qualsiasi messaggio. Vuoi comunque inviare questo messaggio modello o rispondere con un altro messaggio?',
  'dashboard.us_number':
    'I messaggi WhatsApp Business non vengono inviati ai numeri degli Stati Uniti perché Meta ha sospeso tutti i messaggi di marketing verso i numeri statunitensi il 1º aprile 2025.',
  'dashboard.error_msg': 'Completa correttamente tutti i segnaposto.',

  /* Widget web */
  'web-widget.title': 'Menu Web Widget per il chatbot del sito',

  /* Home Page */
  'dashboards.quickstartwithai': 'Avvio rapido con l’IA',
  'dashboards.fastestpathtoautomation':
    'Sei sulla strada più veloce verso l’automazione con strumenti IA',
  'dashboards.insightsthatempower': 'Approfondimenti che potenziano',
  'dashboards.trainchatbot': 'Addestra il chatbot',
  'dashboards.automatewithforms': 'Automatizza con moduli',
  'dashboards.inroomdigitalcompendium': 'Compendio digitale in camera',
  'dashboards.support': 'Supporto',
  'dashboards.helpcenter': 'Centro assistenza',
  'dashboards.searchfaqintegrations':
    'Cerca articoli su FAQ comuni, integrazioni e altro.',
  'dashboards.asklivechat': 'Fai una domanda al nostro team in chat live',
  'dashboards.inroomqrcode':
    'QR code in camera per informazioni sulla struttura e località',
  'dashboards.customizewebwidget':
    'Personalizza e aggiungi il Web Widget al tuo sito con chatbot IA integrato',
  'dashboards.createcustomforms':
    'Crea moduli personalizzati e ricevi notifiche quando un ospite invia un modulo',
  'dashboards.trainchatbotproperty':
    'Addestra il chatbot con informazioni sulla tua struttura come orario check‑in, attività ecc.',
  'dashboards.chatbotinsights':
    'Scopri come il chatbot interagisce con gli ospiti e ottieni statistiche come visitatori web, domande frequenti e molto altro.',
  'dashboards.addaichatbottoyourwebsite': 'Aggiungi chatbot IA al tuo sito',

  /* Statistiche e-mail */
  'dashboards.thread-summary-title': 'Riepiloghi conversazioni',
  'dashboards.thread-summary-subtitle': 'Riepiloghi email generati dall’IA',
  'dashboards.ai-replies-title': 'Risposte IA',
  'dashboards.ai-replies-subtitle': 'Risposte generate dall’IA',
  'dashboards.total-thread-summary-title':
    'Riepiloghi conversazione totali generati',
  'dashboards.total-ai-replies-title': 'Risposte IA totali generate',
  'dashboards.total-draft-copied': 'Bozze copiate dagli utenti',
  'dashboards.urgency': 'Urgenza',
  'dashboards.sentiment': 'Sentimento',
  'dashboards.common-email-reasons': 'Motivi comuni email',
  'dashboards.topics-in-emails': 'Argomenti nelle email',
  'dashboards.email-assistant-usage': 'Utilizzo assistente email IA',
  'dashboards.usage-by-email-address': 'Utilizzo per indirizzo email',

  /* 05. Pagine */
  'pages.title.dashboards.analytics': 'Analisi',
  'pages.title.ari': 'Disponibilità e tariffe',
  'pages.title.conversations': 'Conversazioni',
  'pages.title.bookings': 'Prenotazioni',
  'pages.title.tickets': 'Lead e ticket',
  'pages.title.propinfo': 'Risposte',
  'pages.title.discounts': 'Sconti e promozioni',
  'pages.title.finance': 'Finanza',
  'pages.title.integration': 'Integrazione',
  'pages.title.admin': 'Admin',
  'pages.add-new': 'AGGIUNGI NUOVO',
  'pages.add-new-modal-title': 'Aggiungi elemento nuovo',
  'pages.display-options': 'Opzioni visualizzazione',
  'pages.orderby': 'Ordina per: ',
  'pages.product-name': 'Nome prodotto',
  'pages.category': 'Categoria',
  'pages.description': 'Descrizione',
  'pages.status': 'Stato',
  'pages.cancel': 'Annulla',
  'pages.submit': 'Invia',
  'pages.delete': 'Elimina',
  'pages.another-action': 'Un’altra azione',
  'pages.actions': 'AZIONI',
  'pages.header': 'Intestazione',
  'pages.details': 'DETTAGLI',
  'pages.orders': 'ORDINI',
  'pages.rating': 'Valutazione',
  'pages.price': 'Prezzo',
  'pages.ingredients': 'Ingredienti',
  'pages.is-vegan': 'È vegano',
  'pages.order-status': 'Stato ordine',
  'pages.bake-progress': 'Progresso cottura',
  'pages.popularity': 'Popolarità',
  'pages.comments': 'Commenti',
  'pages.error-title': 'Ooop... sembra che si sia verificato un errore!',
  'pages.error-code': 'Codice errore',
  'pages.go-back-home': 'TORNA ALLA HOME',
  'pages.mailing-info':
    'I template email utilizzano stili inline e layout a tabelle per visualizzarsi correttamente su vari provider. Per una migliore usabilità li includiamo come HTML regolare con dangerouslySetInnerHTML.',
  'pages.invoice-info':
    'Il template fattura ha una versione con stili inline per utilizzo esterno e una versione React.',
  'pages.react-version': 'Versione React',
  'pages.inline-version': 'Versione HTML con stili inline',

  /* 06. Applicazioni */
  /* 06.01. Chat */
  'chat.messages': 'Messaggi',
  'chat.contacts': 'Contatti',
  'chat.saysomething': 'Scrivi qualcosa..',

  /* 06.02. Sondaggi */
  'survey.delete': 'Elimina',
  'survey.edit': 'Modifica',
  'survey.add-new': 'AGGIUNGI NUOVO',
  'survey.add-new-title': 'Aggiungi nuovo sondaggio',
  'survey.title': 'Titolo',
  'survey.category': 'Categoria',
  'survey.label': 'Etichetta',
  'survey.status': 'Stato',
  'survey.cancel': 'Annulla',
  'survey.submit': 'Invia',
  'survey.another-action': 'Un’altra azione',
  'survey.display-options': 'Opzioni visualizzazione',
  'survey.orderby': 'Ordina per: ',
  'survey.all-surveys': 'Tutti i sondaggi',
  'survey.completed-surveys': 'Sondaggi completati',
  'survey.categories': 'Categorie',
  'survey.active-surveys': 'Sondaggi attivi',
  'survey.labels': 'Etichette',

  /* 06.03 Todo */
  'todo.add-new': 'AGGIUNGI NUOVO',
  'todo.add-new-title': 'Aggiungi Nuovo Todo',
  'todo.title': 'Titolo',
  'todo.detail': 'Dettagli',
  'todo.category': 'Categoria',
  'todo.label': 'Etichetta',
  'todo.status': 'Stato',
  'todo.cancel': 'Annulla',
  'todo.submit': 'Invia',
  'todo.action': 'Azione',
  'todo.another-action': 'Altra azione',
  'todo.display-options': 'Opzioni di visualizzazione',
  'todo.orderby': 'Ordina per:',
  'todo.all-tasks': 'Tutte le attività',
  'todo.pending-tasks': 'Attività in sospeso',
  'todo.completed-tasks': 'Attività completate',
  'todo.categories': 'Categorie',
  'todo.labels': 'Etichette',

  /* 07.01 Alerts */
  'alert.rounded': 'Avviso arrotondato',
  'alert.react-notifications': 'Notifiche React',
  'alert.outline': 'Contorno',
  'alert.primary': 'Primario',
  'alert.secondary': 'Secondario',
  'alert.info': 'Informazioni',
  'alert.success': 'Successo',
  'alert.warning': 'Attenzione',
  'alert.error': 'Errore',
  'alert.filled': 'Riempito',
  'alert.primary-text': 'Questo è un avviso primario—dai un’occhiata!',
  'alert.secondary-text': 'Questo è un avviso secondario—dai un’occhiata!',
  'alert.success-text': 'Questo è un avviso di successo—dai un’occhiata!',
  'alert.danger-text': 'Questo è un avviso di pericolo—dai un’occhiata!',
  'alert.warning-text': 'Questo è un avviso di attenzione—dai un’occhiata!',
  'alert.info-text': 'Questo è un avviso informativo—dai un’occhiata!',
  'alert.light-text': 'Questo è un avviso chiaro—dai un’occhiata!',
  'alert.dark-text': 'Questo è un avviso scuro—dai un’occhiata!',
  'alert.default': 'Avviso predefinito',
  'alert.dismissing': 'Avviso chiudibile',
  'alert.dismissing-text':
    'Accidenti! Dovresti verificare alcuni dei campi qui sotto.',
  'alert.dismissing-without-animate-text':
    'Sono un avviso e posso essere chiuso senza animazione!',

  /* 07.02 Badges */
  'badge.sizes': 'Dimensioni',
  'badge.colors': 'Colori',
  'badge.outline': 'Contorno',
  'badge.links': 'Link',
  'badge.counter-badges': 'Badge contatori',
  'badge.bootstrap-default': 'Bootstrap predefinito',
  'badge.primary': 'Primario',
  'badge.secondary': 'Secondario',
  'badge.success': 'Successo',
  'badge.danger': 'Pericolo',
  'badge.warning': 'Attenzione',
  'badge.info': 'Informazioni',
  'badge.light': 'Chiaro',
  'badge.dark': 'Scuro',

  /* 07.03 Buttons */
  'button.default': 'Bootstrap predefinito',
  'button.colors': 'Colori',
  'button.rounded': 'Arrotondato',
  'button.outline': 'Contorno',
  'button.states': 'Stati',
  'button.sizes': 'Dimensioni',
  'button.button-groups': 'Gruppi di pulsanti',
  'button.large-button': 'Pulsante grande',
  'button.small-button': 'Pulsante piccolo',
  'button.extra-small-button': 'Pulsante extra piccolo',
  'button.block-button': 'Pulsante a blocco',
  'button.active': 'Attivo',
  'button.disabled': 'Disabilitato',
  'button.basic': 'Base',
  'button.toolbar': 'Barra degli strumenti',
  'button.nesting': 'Annidamento',
  'button.vertical-variation': 'Variazione verticale',
  'button.checkbox-radio-button': 'Checkbox e radio',
  'button.checkbox': 'Checkbox',
  'button.radio': 'Radio',
  'button.radio-button': 'Pulsante radio',
  'button.primary': 'Primario',
  'button.secondary': 'Secondario',
  'button.success': 'Successo',
  'button.danger': 'Pericolo',
  'button.warning': 'Attenzione',
  'button.info': 'Informazioni',
  'button.light': 'Chiaro',
  'button.dark': 'Scuro',
  'button.states-text':
    'Questo pulsante mostra uno spinner per 2 secondi e un’icona di errore per 3 secondi prima di tornare allo stato normale. Gli stati possono essere attivati aggiungendo o rimuovendo classi.',
  'button.click-here': 'Clicca qui',
  'button.states-text-alternate':
    'Questo pulsante mostra uno spinner per 2 secondi e un’icona di errore per 3 secondi prima di tornare allo stato normale. Gli stati possono essere attivati aggiungendo o rimuovendo classi.',
  'button.primary-link': 'Link primario',
  'button.link': 'Link',
  'button.primary-button': 'Pulsante primario',
  'button.button': 'Pulsante',
  'button.left': 'Sinistra',
  'button.middle': 'Centro',
  'button.right': 'Destra',
  'button.dropdown': 'Dropdown',
  'button.dropdown-link': 'Link dropdown',

  /* 07.04 Cards */
  'cards.icon-card': 'Scheda icona',
  'cards.image-card': 'Scheda immagine',
  'cards.image-overlay-card': 'Scheda con sovrapposizione immagine',
  'cards.image-card-list': 'Elenco schede immagine',
  'cards.tab-card': 'Scheda tab',
  'cards.user-card': 'Scheda utente',

  /* 07.05 Carousel */
  'carousel.basic': 'Carousel base',
  'carousel.single': 'Carousel singolo',
  'carousel.without-controls': 'Carousel senza controlli',

  /* 07.06 Charts */
  'charts.line': 'Grafico a linee',
  'charts.polar': 'Grafico polare',
  'charts.area': 'Grafico ad area',
  'charts.scatter': 'Grafico a dispersione',
  'charts.bar': 'Grafico a barre',
  'charts.radar': 'Grafico radar',
  'charts.pie': 'Grafico a torta',
  'charts.doughnut': 'Grafico a ciambella',
  'charts.shadow': 'Con ombra',
  'charts.no-shadow': 'Senza ombra',

  /* 07.07 Collapse */
  'collapse.basic': 'Base',
  'collapse.toggle': 'Toggle',
  'collapse.accordion': 'Accordion',
  'collapse.controlled': 'Controllato',
  'collapse.uncontrolled': 'Non controllato',

  /* 07.08 Dropdowns */
  'dropdowns.basic': 'Base',
  'dropdowns.controlled': 'Controllato',
  'dropdowns.uncontrolled': 'Non controllato',
  'dropdowns.dropdown': 'Dropdown',
  'dropdowns.header': 'Intestazione',
  'dropdowns.action': 'Azione',
  'dropdowns.another-action': 'Altra azione',
  'dropdowns.right': 'Destra',
  'dropdowns.left': 'Sinistra',
  'dropdowns.drop-directions': 'Direzioni drop',
  'dropdowns.dropright': 'Drop a destra',
  'dropdowns.dropleft': 'Drop a sinistra',
  'dropdowns.small-button': 'Pulsante piccolo',
  'dropdowns.large-button': 'Pulsante grande',
  'dropdowns.sizing': 'Dimensionamento',
  'dropdowns.split-button': 'Dropdown pulsante diviso',
  'dropdowns.dropup': 'Drop verso l’alto',

  /* 07.09 Editors */
  'editors.draftjs': 'Draft.js',
  'editors.quill-standart': 'Quill standard',
  'editors.quill-bubble': 'Quill bubble',

  /* 07.10 Forms */
  'forms.basic': 'Base',
  'forms.email': 'E‑mail',
  'forms.email-muted': 'Non condivideremo mai la tua email con nessuno.',
  'forms.password': 'Password',
  'forms.submit': 'Invia',
  'forms.horizontal': 'Orizzontale',
  'forms.radios': 'Radio',
  'forms.first-radio': 'Prima radio',
  'forms.second-radio': 'Seconda radio',
  'forms.third-radio-disabled': 'Terza radio disabilitata',
  'forms.checkbox': 'Checkbox',
  'forms.signin': 'Accedi',
  'forms.top-labels-over-line': 'Etichette sopra la linea',
  'forms.tags': 'Tag',
  'forms.date': 'Data',
  'forms.state': 'Stato',
  'forms.top-labels-in-input': 'Etichette sopra l’input',
  'forms.email-u': 'E‑MAIL',
  'forms.password-u': 'PASSWORD',
  'forms.tags-u': 'TAG',
  'forms.date-u': 'DATA',
  'forms.state-u': 'STATO',
  'forms.grid': 'Griglia modulo',
  'forms.address': 'Indirizzo',
  'forms.address2': 'Indirizzo 2',
  'forms.city': 'Città',
  'forms.city-message': 'Seleziona una città!',
  'forms.state-message': 'Seleziona uno stato!',
  'forms.zip': 'CAP',
  'forms.signup': 'Registrati',
  'forms.inline': 'Inline',
  'forms.validation-availity': 'Validazione Availity Reactstrap',
  'forms.validation-formik': 'Validazione Formik',
  'forms.default': 'Predefinito',
  'forms.firstname': 'Nome',
  'forms.firstname-message': 'Inserisci il tuo nome!',
  'forms.lastname': 'Cognome',
  'forms.lastname-message': 'Inserisci il tuo cognome!',

  /* 07.11 Form Components */
  'form-components.custom-inputs': 'Input personalizzati',
  'form-components.checkboxes': 'Checkbox',
  'form-components.radios': 'Radio',
  'form-components.inline': 'Inline',
  'form-components.react-select': 'React Select',
  'form-components.state-single': 'Singolo stato',
  'form-components.state-multiple': 'Stati multipli',
  'form-components.react-autosuggest': 'React Autosuggest',
  'form-components.date-picker': 'Selettore data',
  'form-components.date': 'Data',
  'form-components.date-range': 'Intervallo di date',
  'form-components.date-with-time': 'Data e ora',
  'form-components.embedded': 'Incorporato',
  'form-components.dropzone': 'Dropzone',
  'form-components.drop-files-here': 'Rilascia file qui',
  'form-components.tags': 'Tag',
  'form-components.switch': 'Interruttore',
  'form-components.primary': 'Primario',
  'form-components.secondary': 'Secondario',
  'form-components.primary-inverse': 'Primario inverso',
  'form-components.secondary-inverse': 'Secondario inverso',
  'form-components.slider': 'Slider',
  'form-components.double-slider': 'Doppio slider',
  'form-components.single-slider': 'Slider singolo',
  'form-components.rating': 'Valutazione',
  'form-components.interactive': 'Interattivo',
  'form-components.readonly': 'Sola lettura',
  'form-components.type-a-cake': 'Digita una torta',
  'form-components.start': 'Inizio',
  'form-components.end': 'Fine',
  'form-components.tables': 'Tabelle',

  /* 07.12 Icons */
  'icons.simplelineicons': 'Icone Simple Line',
  'icons.iconsmind': 'Icone Iconsmind',

  /* 07.13 Input Groups */
  'input-groups.basic': 'Base',
  'input-groups.sizing': 'Dimensionamento',
  'input-groups.small': 'Piccolo',
  'input-groups.default': 'Predefinito',
  'input-groups.large': 'Grande',
  'input-groups.checkboxes-and-radios': 'Checkbox e radio',
  'input-groups.multiple-inputs': 'Input multipli',
  'input-groups.first-and-last-name': 'Nome e cognome',
  'input-groups.multiple-addons': 'Componenti aggiuntivi multipli',
  'input-groups.button-addons': 'Componenti aggiuntivi pulsante',
  'input-groups.button': 'Pulsante',
  'input-groups.buttons-with-dropdowns': 'Pulsanti con dropdown',
  'input-groups.dropdown': 'Dropdown',
  'input-groups.header': 'Intestazione',
  'input-groups.action': 'Azione',
  'input-groups.another-action': 'Altra azione',
  'input-groups.custom-select': 'Select personalizzato',
  'input-groups.options': 'Opzioni',
  'input-groups.choose': 'Scegli…',
  'input-groups.custom-file-input': 'Input file personalizzato',

  /* 07.14 Jumbotron */
  'jumbotron.hello-world': 'Ciao, mondo!',
  'jumbotron.lead':
    'Questo è un componente eroe semplice, in stile jumbotron, che attira l’attenzione su contenuti o informazioni in evidenza.',
  'jumbotron.lead-detail':
    'Utilizza classi di utilità per tipografia e spaziatura per distanziare i contenuti all’interno del contenitore più ampio.',
  'jumbotron.learn-more': 'Scopri di più',

  /* 07.15 Modal */
  'modal.basic': 'Base',
  'modal.modal-title': 'Titolo modale',
  'modal.launch-demo-modal': 'Apri demo modale',
  'modal.scrolling-long-content': 'Contenuto lungo a scorrimento',
  'modal.backdrop': 'Backdrop',
  'modal.backdrop-value': 'Valore backdrop',
  'modal.right-modal': 'Modale a destra',
  'modal.launch-right-modal': 'Apri modale a destra',
  'modal.nested-modal': 'Modale annidato',
  'modal.size': 'Dimensione',
  'modal.launch-large-modal': 'Apri modale grande',
  'modal.launch-small-modal': 'Apri modale piccola',

  /* 07.16 Navigation */
  'nav.basic': 'Navigazione base',
  'nav.active': 'Attiva',
  'nav.disabled': 'Disabilitata',
  'nav.disabled-link': 'Link disabilitato',
  'nav.link': 'Link',
  'nav.longer-link': 'Link più lungo',
  'nav.another-link': 'Un altro link',
  'nav.right': 'Destra',
  'nav.dropdown': 'Dropdown',
  'nav.header': 'Intestazione',
  'nav.action': 'Azione',
  'nav.another-action': 'Altra azione',
  'nav.horizontal-alignment': 'Allineamento orizzontale',
  'nav.vertical-alignment': 'Allineamento verticale',
  'nav.pills': 'Pillole di navigazione',
  'nav.fill-justify': 'Riempimento e giustifica',
  'nav.pills-dropdowns': 'Pillole con dropdown',
  'nav.pagination-basic': 'Paginazione base',
  'nav.pagination-sizing': 'Dimensionamento paginazione',
  'nav.large': 'Grande',
  'nav.small': 'Piccolo',
  'nav.center': 'Centro',
  'nav.pagination-alignment': 'Allineamento paginazione',
  'nav.breadcrumb-basic': 'Breadcrumb base',

  /* 07.17.Popover & Tooltip */
  'popover-tooltip.popover': 'Finestra informativa',
  'popover-tooltip.tooltip': 'Suggerimento',

  /* 07.18.Sortable */
  'sortable.columns': 'Ordinamento colonne',
  'sortable.basic': 'Base',
  'sortable.handles': 'Maniglie',

  /* 07.19.Maps */
  'maps.google': 'Google',
  'maps.yandex': 'Yandex',

  /* 07.20.Tables */
  'table.bootstrap-tables': 'Tabelle Bootstrap',
  'table.bootstrap-basic': 'Tabella base',
  'table.bootstrap-striped': 'Righe alternate',
  'table.bootstrap-bordered': 'Tabella con bordi',
  'table.bootstrap-borderless': 'Tabella senza bordi',
  'table.bootstrap-hoverable': 'Righe evidenziabili',
  'table.bootstrap-responsive': 'Tabella reattiva',
  'table.react-tables': 'Tabelle React',
  'table.react-pagination': 'Paginazione',
  'table.react-scrollable': 'Scorribile',
  'table.react-advanced': 'Filtro, lunghezza e salto',

  /* Property Info */
  'property-info.allcustomers': 'Tutti i clienti',
  'property-info.external-sources': 'Fonti esterne',
  'property-info.faq': 'Domande frequenti',
  'property-info.documents': 'Documenti',
  'property-info.publish-ai': 'Pubblica AI',
  'property-info.pre-built-templates': 'Modelli predefiniti',
  'property-info.room-types': 'Tipi di stanza',
  'property-info.about-property': 'Informazioni sulla proprietà',
  'property-info.about-properties': 'Informazioni sulle proprietà',
  'property-info.facilities-services': 'Servizi e strutture',
  'property-info.property-facilities': 'Strutture della proprietà',
  'property-info.room-amenities': 'Servizi in camera',
  'property-info.property-contact': 'Contatto della proprietà',
  'property-info.property-activities': 'Attività della proprietà',
  'property-info.property-location': 'Posizione della proprietà',
  'property-info.about-rooms': 'Camere',
  'property-info.about-sites': 'Informazioni sui siti',
  'property-info.special-emergencies': 'Emergenze',
  'property-info.gallery': 'Galleria',
  'property-info.policies': 'Politiche',
  'property-info.nearby': 'Nelle vicinanze',
  'property-info.transport': 'Trasporti',
  'property-info.location': 'Posizione',
  'property-info.about-rhproperty': 'Informazioni sulla casa di riposo',
  'property-info.related-topics': 'Argomenti correlati',
  'property-info.assistant-options': 'Messaggio di benvenuto',
  'property-info.restaurant-assistant-information':
    'Informazioni sul ristorante',
  'property-info.restaurant-assistant-options': 'Messaggio di benvenuto',
  'property-info.channel-messages': 'Messaggi del canale',
  'property-info.icon.gallery': 'Libreria icone',
  'property-info.copilot': 'Copilot',
  'property-info.sprint': 'Sprint',
  'property-info.home-information': 'Informazioni sulla casa',
  'property-info.loction': 'Posizioni',
  'property-info.rooms-and-images': 'Camere e immagini',
  'property-info.trainig-data': 'Dati di addestramento AI',
  'property-info.publishMonitor': 'Pubblica e monitora',
  'property-info.webWidget': 'Widget web',
  'property-info.media': 'Media',
  'property-info.flows': 'Flussi',
  'property-info.add-your-own': 'Aggiungi il tuo',
  'property-info-utility-miscellaneous': 'Varie',
  'property-info-utility-payment': 'Pagamenti',
  'property-info-utility-broadband': 'Banda larga',
  'property-info-utility-emergency': 'Emergenza',
  'property-info-utility-mobile': 'Cellulare',
  'property-info-utility-moving': 'Trasloco',

  /** Rate & Promo */
  'rate-promo.rate-plans': 'Piani tariffari',
  'rate-promo.rate-plan-addons': 'Componenti aggiuntivi',
  'rate-promo.rate-plan-promos': 'Promozioni',

  'title.property-information': 'Informazioni sulla proprietà',

  'property.message': 'Messaggio',
  'property.example': 'Esempio',
  'property.link': 'Link',
  'property.image-carousel': 'Carosello immagini',
  'property.Title': 'Titolo',
  'property.SubTitle': 'Sottotitolo',

  'property.add-invoke-api': 'Richiama API',
  'property.add-message-button': 'Aggiungi messaggi',
  'property.add-img-button': 'Aggiungi immagini',
  'property.add-link-button': 'Aggiungi link',

  'property.add-herocard-button': 'Aggiungi Hero Card',
  'property.add-api-button': 'Aggiungi pulsanti',

  /* Menu */
  'menu.settings': 'Impostazioni',
  'menu.workflows': 'Flussi di lavoro',
  'menu.product_services': 'Prodotti & Servizi',
  'menu.product_recommander': 'Consigliatore di prod.',
  'menu.digital_guide_book': 'Guida digitale',
  'menu.welcome_message': 'Messaggio di benvenuto',
  'menu.about-property': 'Informazioni sulla struttura',
  'menu.property-facilities': 'Servizi della struttura',
  'menu.room-amenities': 'Servizi della stanza',
  'menu.property-contact': 'Contatti della struttura',
  'menu.about-rooms': 'Camere',
  'menu.special-emergencies': 'Emergenze',
  'menu.show-filter': 'Filtri',
  'menu.new': 'Nuovo',
  'menu.channel': 'Canali',
  'menu.application': 'Applicazioni',

  /* Dashboards – interactive actions */
  'dashboards.send': 'Invia',
  'dashboards.hello': 'Ciao',
  'dashboards.notificationsAllowed': 'Notifiche consentite',
  'dashboards.allowNotifications': 'Consenti notifiche',
  'dashboards.views': 'Visualizzazioni',
  'dashboards.bookingURL': 'URL prenotazione',
  'dashboards.searchTags': 'Cerca tag',
  'dashboards.searchCategoryTags': 'Cerca tag di categoria',
  'dashboards.bedroom': 'Camera da letto',
  'dashboards.addBedroom': 'Aggiungi camera',
  'dashboards.frequency': 'Frequenza',
  'dashboards.includeSubpages': 'Includi sottopagine',
  'dashboards.enableFaqs': 'Abilita FAQ',
  'dashboards.faqsDescription':
    'Abilitando le FAQ puoi inserire domande mentre il sistema estrae le risposte dalla pagina web per creare FAQ complete',
  'dashboards.faq': 'FAQ',
  'dashboards.deleteDocument': 'Elimina documento',
  'dashboards.confirmDelete': 'Sei sicuro di voler eliminare?',
  'dashboards.addItem': 'Aggiungi elemento',
  'dashboards.addFirstWebPage': 'Aggiungi la tua prima pagina web',

  /* Dashboards – analytics insights */
  'dashboards.popular-compendium': 'Voci di compendio popolari',
  'dashboards.wordcloudofcompendium': 'Word cloud delle voci del compendio',
  'dashboards.wordcloudonthings':
    'Word cloud su ciò che i visitatori chiedono al sito & voci compendio',
  'dashboards.common-asked': 'Domande frequenti & voci pop.',
  'dashboards.website-visitor-asking': 'Cosa chiedono i visitatori del sito',
  'dashboards.visit-country': 'Visite al sito per paese',
  'dashboards.visit-traffic': 'Paese del traffico web',
  'dashboards.rooms-product': 'Camere & Prodotti',
  'dashboards.popular-room-product': 'Camere e prodotti popolari',

  'dashboards.messenger-stats': 'Voci del menu popolari',
  'dashboards.messenger-stats-topic-view':
    'Statistiche visualizzazioni voci menu',
  'dashboards.messenger-stats-visits': 'Visualizzazioni voci menu',
  'dashboards.opening-menu-items':
    'Numero di visitatori che aprono voci del menu',

  'dashboards.number-totalavatarclick': 'Totale click avatar',
  'dashboards.clicks': 'Click',
  'dashboards.leads': 'Lead',
  'dashboards.hours': 'Ore',
  'dashboards.minutes': 'Minuti',
  'dashboards.connect': 'Connetti',
  'dashboards.ai-chatbot': 'Chatbot IA',
  'dashboards.compendium': 'Compendio',
  'dashboards.compendium-digital-usage': 'Utilizzo compendio digitale',
  'dashboards.compendium-unique-visits': 'Scansioni/click QR code',
  'dashboards.compendium-opening-menu-items': 'Voci del menu visualizzate',
  'dashboards.compendium-total-digital-clicks':
    'Totale visualizzazioni voci menu',
  'dashboards.compendium-total-qr-code': 'Totale scansioni QR code',
  'dashboards.compendium-avg-menu-items': 'Media voci menu per scansione',
  'dashboards.top-clicked-urls': 'URL più cliccate',
  'dashboards.top-clicked-urls-description': 'Analisi dei clic URL',
  'dashboards.urls': 'URL',
  'dashboards.externalDeleteMessage':
    'Questo documento è stato generato da fonti esterne. Se non desideri che venga ricreato, assicurati di rimuovere anche la pianificazione della sincronizzazione associata.',
  'dashboards.deleteAndGoToExternalSources': 'Elimina e vai alle fonti esterne',

  /* Property & User Roles */
  'property.delete': 'Elimina',
  'menu.userroles': 'Utenti & Ruoli',
  'menu.members': 'Membri',
  'menu.guest-pass': 'Pass ospiti & punti',
  'menu.ratebookings': 'Tariffe & Prenotazioni',

  /* Digital Assistant & Visitor Interactions */
  'dashboards.engagement-time': 'Tempo engagement Assistente Digitale',
  'dashboards.conversations-minutes':
    'Minuti totali & notturni (19–07) nelle conversazioni',
  'dashboards.visitor-questions': 'Domande dei visitatori',
  'dashboards.recent-queries': 'Query recenti',
  'dashboards.visitor-saying':
    'Cosa dicono i visitatori all’Assistente Digitale',
  'dashboards.contacts-prechatform-leavemessage':
    'Contatti memorizzati da modulo pre‑chat & lascia messaggio',

  /* Menu insights & other flows */
  'menu.dashboards': 'Approfondimenti',
  'menu.ari': 'Disponibilità e Tariffe',
  'menu.conversations': 'Conversazioni',
  'menu.conversations.unified-inbox': 'Posta Unificata',
  'menu.conversations.active': 'Assistente Agente',
  'menu.conversations.archives': 'Archivi',
  'menu.conversations.missed-responses': 'Risposte Mancate',
  'menu.conversations.ticket': 'Ticket',
  'menu.conversations.reply-templates': 'Modelli di Risposta',
  'menu.bookings': 'Prenotazioni',
  'menu.tickets': 'Lead e Ticket',
  'menu.propinfo': 'Centro di Conoscenza',
  'menu.rate-promos': 'Tariffe e Promozioni',
  'menu.finance': 'Finanza',
  'menu.integration': 'Integrazione',
  'menu.admin': 'Amministrazione e Sicurezza',
  'menu.favourites': 'Preferiti',
  'menu.recommender': 'Flussi Conversazionali',
  'menu.assistant-setup': 'Configurazione Assistente',
  'menu.admin-insights': 'Approfondimenti Admin',
  'menu.super-admin': 'Super amministratore',
  'menu.groups': 'Gruppi',
  'menu.properties': 'Proprietà',
  'menu.service-provider': 'Fornitori di Servizi',
  'menu.spaces': 'Spazi',
  'menu.content-manager': 'Gestione dei Contenuti',
  'menu.events-calendar': 'Calendario Eventi',
  'menu.appearance-settings': 'Aspetto e Impostazioni',
  'menu.help': 'Aiuto',
  'menu.availability': 'Disponibilità',
  'menu.myAccounts': 'I Miei Account',
  'menu.guest-messaging': 'Messaggistica ospiti',
  'guest-messaging.settings': 'Impostazioni',
  'guest-messaging.outreach-setup': 'Impostazione Outreach',
  'guest-messaging.reservations': 'Prenotazioni',
  'guest-messaging.insights_logs': 'Analisi e registri',
  'guest-messaging.placeholder':
    'Il modulo Messaggistica ospiti arriverà presto.',
  'guest-messaging.settings.placeholder':
    'Imposta le preferenze di messaggistica ospiti.',
  'guest-messaging.outreach.placeholder':
    'Imposta campagne e modelli per outreach.',
  'guest-messaging.reservations.placeholder':
    'Gestisci messaggi delle prenotazioni.',
  'guest-messaging.reservation-source': 'Fonte dati prenotazioni',
  'guest-messaging.communication-channels': 'Canali di comunicazione',
  'guest-messaging.templates': 'Modelli',
  'guest-messaging.link': 'Link',
  'guest-messaging.business-profile': 'Profilo aziendale',

  /* More dashboards tools & dates */
  'dashboards.tickets-by-category': 'Ticket per categoria',
  'dashboards.download': 'Scarica',
  'dashboards.space-booking': 'Prenotazione spazio',
  'dashboards.gift-voucher': 'Buoni regalo',
  'dashboards.chatbots': 'Chatbot',
  'dashboards.form': 'Da',
  'dashboards.to': 'A',
  'dashboards.active-groups': 'Gruppi attivi',
  'dashboards.active-properties': 'Proprietà attive',
  'dashboards.live-properties': 'Proprietà attive (live)',
  'dashboards.properties-going':
    'Proprietà che diventano live per intervallo date',
  'dashboards.start-date': 'Data inizio',
  'dashboards.end-date': 'Data fine',
  'dashboards.all-properties-with': 'Tutte le proprietà con stato live',
  'dashboards.aibot-by-country': 'Clienti Chatbot IA per paese',
  'dashboards.list-live-clients': 'Elenco clienti live con chatbot IA',
  'dashboards.subscribe-to-reports': 'Iscriviti ai report',
  'dashboards.website-visits': 'Visite sito',
  'dashboards.unique-visitors': 'Visitatori unici',
  'dashboards.last-week': 'Settimana scorsa',
  'dashboards.this-week': 'Questa settimana',
  'dashboards.this-month': 'Questo mese',
  'dashboards.previous-month': 'Mese precedente',
  'dashboards.yeartodate': 'Anno in corso',
  'dashboards.lastyear': 'Anno scorso',
  'dashboards.last-7-days': 'Ultimi 7 giorni',
  'dashboards.last-30-days': 'Ultimi 30 giorni',
  'dashboards.last-60-days': 'Ultimi 60 giorni',
  'dashboards.last-90-days': 'Ultimi 90 giorni',
  'dashboards.conversion-rates': 'Tassi di conversione',
  'dashboards.digital-assistant-engagement': 'Engagement Assist. Digitale',
  'dashboards.total-overnight-conversations': 'Conversazioni totali & notturne',
  'dashboards.percentage-accuracy': 'Copertura della conoscenza',
  'dashboards.percentage-conversion': 'Conversione traffico web → chat',
  'dashboards.percentage-avatarclick': 'Traffico web → click avatar',
  'dashboards.percentage-negativefeedback':
    'Feedback negativi (%) click avatar',
  'dashboards.percentage-amenties': 'Query servizi',
  'dashboards.percentage-booking': 'Richieste prenotazione',
  'dashboards.percentage-webchats': 'Chat sul sito',
  'dashboards.percentage-facebookchat': 'Chat Facebook',
  'dashboards.number-webchattime': 'Tempo totale conversazione',
  'dashboards.number-totalconversation': 'Conversazioni totali',
  'dashboards.number-averagetimeconversation': 'Tempo medio per conversazione',
  'dashboards.number-websiteconversation': 'Conversazioni sul sito',
  'dashboards.number-facebookconversation': 'Conversazioni Facebook',
  'dashboards.number-estimatedtimesaving': 'Tempo stimato risparmiato',
  'dashboards.number-googlemapsconversation': 'Conversazioni Google Maps',
  'dashboards.number-whatsappconversation': 'Conversazioni WhatsApp',
  'dashboards.number-instagramconversation': 'Conversazioni Instagram',
  'dashboards.number-agentconversation': 'Conversazioni agente',
  'dashboards.number-amenityqueries': 'Query sui servizi',
  'dashboards.number-bookingenquiries': 'Richieste prenotazione',
  'dashboards.number-groupbookingenquiries': 'Richieste prenotazione gruppi',
  'dashboards.number-eventenquiries': 'Richieste eventi',
  'dashboards.number-longstayenquiries': 'Richieste soggiorno lungo',
  'dashboards.number-totaltickets': 'Numero ticket',
  'dashboards.number-returncustomer': 'Cliente di ritorno',
  'dashboards.number-redirects': 'Redirect sito',
  'dashboards.number-bookingengineleads': 'Lead motore prenotazioni',
  'dashboards.number-roomnightsreferred': 'Notti camere riferite',
  'dashboards.number-revenuereferred': 'Ricavi riferiti',
  'menu.bookingsmenu': 'Prenotazioni',
  'menu.guests': 'Info ospiti',
  'menu.whatsnew': "Cosa c'è di nuovo",

  'dashboards.welcomeMessage': 'Messaggio di benvenuto',
  'dashboards.personalizeGreeting':
    "Personalizza il modo in cui i clienti vengono accolti per riflettere il tuo marchio, stile ed etichetta, assicurandoti che ricevano un caloroso benvenuto. Personalizza i saluti per riflettere il tuo marchio e creare un'accoglienza calorosa.",
  'dashboards.addRoomDetails':
    'Aggiungi dettagli su ciascuna delle tue camere in modo che gli ospiti possano facilmente scoprire tutto ciò di cui hanno bisogno per scegliere la soluzione perfetta e rendere il processo di prenotazione più semplice e veloce.',
  'dashboards.trainAIFAQs': 'Allena l’IA con domande frequenti',
  'dashboards.manualQuestions':
    'Alcune domande non possono essere risposte con documenti o trovate sul sito Web. Qui puoi aggiungere manualmente domande per garantire che i clienti abbiano sempre le informazioni di cui hanno bisogno a portata di mano.',
  'dashboards.trainAI': 'Allena l’IA con documenti',
  'dashboards.uploadDocuments':
    'Carica documenti per aiutare la tua IA a conoscere la tua attività e assistere i clienti proprio come faresti tu. Puoi aggiungere file in formato .doc, .pdf o .txt.',
  'dashboards.publishAI':
    'Pubblica l’IA per riflettere gli aggiornamenti più recenti',
  'dashboards.retrainAfterChanges':
    'Quando apporti modifiche nel Knowledge Hub o nei moduli, assicurati di riaddestrare il chatbot con le informazioni aggiornate. Pubblicare la tua IA garantisce che il chatbot fornisca le risposte più accurate e aggiornate.',
  'dashboards.enhanceKnowledge':
    'Migliora la conoscenza dell’IA tracciando le query senza risposta',
  'dashboards.reviewUnanswered':
    'Ogni volta che l’IA non può rispondere a una domanda o fornisce solo dettagli limitati, troverai queste query qui. Esaminale per identificare lacune nel tuo Knowledge Hub o domande uniche degli ospiti.',
  'dashboards.manageMedia': 'Gestisci Media',
  'dashboards.mediaGallery':
    'Ogni volta che carichi immagini come stanze, servizi, loghi o il tuo avatar digitale, appariranno in questa galleria, offrendoti un luogo centrale per gestire i contenuti visivi e assicurarti che i tuoi ospiti vedano cosa rende unico il tuo business.',
  'dashboards.createForms':
    'Crea moduli facilmente e ricevi una notifica ad ogni invio.',
  'dashboards.manageForms':
    'Crea e gestisci moduli per raccogliere informazioni sui clienti, impostare notifiche e personalizzarli per diverse lingue.',
  'dashboards.personalizeResponse':
    'Personalizza lo stile di risposta e come procede la conversazione',
  'dashboards.controlConversation':
    'Questa funzione avanzata ti dà la capacità di modellare e controllare come si sviluppano le conversazioni con i tuoi clienti attraverso diversi canali.',

  /* Form builder & virtual front desk */
  'menu.formbuilder': 'Costruttore modulo',
  'forms.forms-title': 'Modulo',
  'menu.virtualfrontdesk': 'Reception virtuale',
  'menu.guestservice': 'Servizi ospite',
  'virtual-front.common-questions': 'Domande frequenti',
  'virtual-front.add-on-upsells': 'Add-on & Upsell',
  'virtual-front.service-order': 'Ordini servizio',
  'virtual-front.guest-service-add-on-upsells': 'Compendio digitale',
  'virtual-front.outbound': 'In uscita',
  'virtual-messenger': 'Menu Web Widget',

  /* Content & inbox support */
  'missed-response.missed-response-title': 'Titolo risposta mancata',
  'content.allconversation': 'Tutte le conversazioni',
  'content.active': 'Attiva',
  'content.tickets': 'Ticket',
  'content.filter': 'Filtro',
  'content.createtickets': 'Crea ticket',
  'content.conversation': 'Conversazione',
  'content.knowledgesearch': 'Ricerca conoscenza',
  'content.reply': 'Rispondi',
  'content.visitorinfo': 'Info visitatore',
  'content.callinfo': 'Info chiamata',
  'content.allinsights': 'Tutti gli insight',
  'content.availabilityrates': 'Disponibilità & Tariffe',
  'content.callback': 'Richiama',
  'content.close': 'Chiudi',
  'content.sms': 'SMS',
  'content.timestamp': 'Timestamp',
  'content.topics': 'Argomenti',
  'content.callingparty': 'Parte chiamante',
  'content.accountdomain': 'Dominio account',
  'content.calledparty': 'Parte chiamata',
  'content.recording': 'Registrazione',
  'content.phonesystemoriginationcallid':
    'ID chiamata orig. sistema telefonico',
  'content.phonesystemterminationcallid':
    'ID chiamata term. sistema telefonico',
  'content.uniqueconversationid': 'ID conversazione univoco',
  'content.regenerateinsights': 'Rigenera insight',
  'content.customersentiment': 'Sentimento cliente',
  'content.neutral': 'Neutro',
  'content.conversationinsights': 'Insight conversazione',
  'content.customeridverification': 'Verifica ID cliente',
  'content.serviceactivationdate': 'Data attivazione servizio',
  'content.followups': 'Follow-up',
  'content.actionneeded': 'Azione necessaria',
  'content.uniqueConversationId': 'ID conversazione univo',
  'content.uniqueChatId': 'ID chat univoco',
  'content.recording&transcript': 'Registrazione & trascrizione',
  'content.chatinsights': 'Insight chat',
  'content.visitedpages': 'Pagine visitate',
  'content.deviceinfo': 'Info dispositivo',
  'content.chatstartedonthispage': 'Chat iniziata su questa pagina',
  'content.prechatinfo': 'Info pre-chat',
  'content.notes': 'Note',
  'content.reassign': 'Riassegna',
  'content.open': 'Apri',
  'content.dismiss': 'Chiudi',
  'content.add_placeholder': 'Aggiungi valori segnaposto',
  'content.mobile_number': 'Numero di cellulare',
  'content.please_select': 'Seleziona',
  'content.sendwhatsapp': 'Invia messaggio WhatsApp',

  /* Missed-response */
  'feedback.missed-question': 'Domanda mancata',
  'feedback.conversation-summary': 'Riepilogo conversazione',
  'feedback.dates-in-spanish': 'Le date devono essere in spagnolo',
  'feedback.resolve': 'Risolvi',
  'feedback.ignore': 'Ignora',

  /* Integration settings */
  'integration.select_properties': 'Seleziona proprietà',
  'integration.select_properties_enabled':
    'Seleziona proprietà abilitate con questa integrazione',
  'integration.services_addons': 'Seleziona servizi & add-on',
  'integration.services_visible':
    'Seleziona servizi & add-on visibili in questa pagina',
  'integration.appearance': 'Aspetto',
  'integration.appearance_customize':
    'Scegli nome, avatar e colori del tuo assistente digitale',
  'integration.booking_calendar': 'Calendario prenotazioni',
  'integration.booking_calendar_style':
    'Scegli stile popup calendario prenotazioni',
  'integration.nudges': 'Promemoria',
  'integration.nudges_setup':
    'Imposta messaggi proattivi per coinvolgere i visitatori',
  'integration.position': 'Posizione',
  'integration.position_control':
    'Controlla la posizione del widget di chat sul sito',
  'integration.custom_fonts': 'Font personalizzati',
  'integration.custom_fonts_upload': 'Carica font personalizzati per la pagina',
  'integration.custom_css': 'CSS personalizzato',
  'integration.custom_css_usage':
    'Usa CSS per personalizzare il Compendio digitale',
  'integration.location': 'Posizione',
  'integration.location_embed': 'Aggiungi URL embed posizione',
  'integration.external_links': 'Link esterni',
  'integration.external_links_add': 'Aggiungi link',
  'integration.language': 'Lingua',
  'integration.widget_languages': 'Seleziona lingue per il widget chat',
  'integration.chatbot_contact': 'Chatbot ',
  'integration.chatbot_enable': 'Abilita assistente digitale',
  'integration.chatbot_security': 'Mantieni Messenger sicuro',
  'integration.chatbot_trusted_pages':
    'Elenca pagine affidabili per mostrare il chatbot',
  'integration.chatbot_publish': 'Pubblica assistente digitale',
  'integration.chatbot_install':
    'Copia snippet codice per installare assistente digitale',
  'integration.google_analytics': 'Monitoraggio Google Analytics',
  'integration.google_analytics_desc':
    "Tieni traccia dell'attività utente, delle sessioni e delle azioni chiave nel widget web usando GA4.",
  'integration.enable_ga4': 'Abilita Google Analytics',
  'integration.ga4_measurement_id': 'ID misurazione GA4',
  'integration.ga4_id_example': 'Esempio: G-ABCD123456',
  'integration.track_events': 'Traccia eventi',
  'integration.track_events_desc':
    'Scegli quali azioni utente inviare come eventi GA4.',
  'integration.avatar_click': 'Clic su avatar',
  'integration.avatar_click_desc':
    'Traccia quando l’utente fa clic sull’avatar della chat.',
  'integration.menu_click': 'Clic sul menu',
  'integration.menu_click_desc':
    'Traccia quando l’utente apre il menu del widget web.',
  'integration.chat_started': 'Chat avviata',
  'integration.chat_started_desc':
    'Traccia il primo messaggio utente una volta per sessione.',
  'integration.event_tag': 'Tag evento',
  'integration.event_prefix': 'Prefisso evento',
  'integration.final_tag': 'Tag finale',
  'integration.example_event': 'Evento di esempio',
  'integration.once_per_session': 'Una sola volta per sessione',
  'integration.saving': 'Salvataggio...',
  'integration.save_ga4_settings': 'Salva impostazioni GA4',
};
export default itMessages;
